import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import ModalCrud from "./Modal";
import { DoLogout, GetDojoName, GetGradeName } from "../Utils";
import Pagination from "../Pagination/Pagination";

export default function ExaminePrevList() {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const displayFormat = "DD/MM/YYYY";
  var moment = require("moment");

  const PAGE_SIZE = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});

  const [isLoading, setLoading] = useState(false);
  const [exams, setExams] = useState([]);
  const [dojos, setDojos] = useState([]);
  const [grades, setGrades] = useState([]);
  const [teachers, setTeachers] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [examDetail, setExamDetail] = useState(null);

  const token = JSON.parse(ls.get("jwt"));
  const usuario = JSON.parse(ls.get("userData"));

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    BuildBase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    GetExams(dojos, grades, teachers, currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const BuildBase = async () => {
    setLoading(true);

    const dojos = await axios
      .get(
        `${API_URL}/dojos?sort[0]=name%3Aasc&fields[0]=id&fields[1]=name&pagination[pageSize]=1000`,
        headerRequest
      )
      .catch((error) => {
        if (error.response.status === 401) DoLogout();
      });
    setDojos(dojos.data.data);

    const grades = await axios.get(
      `${API_URL}/grades?sort[0]=id%3Aasc&fields[0]=id&fields[1]=name&fields[2]=rank`,
      headerRequest
    );
    setGrades(grades.data.data);

    const teachers = await axios.get(
      `${API_URL}/teachers/?sort[0]=name%3Aasc&populate=user`,
      headerRequest
    );
    setTeachers(teachers.data.data);

    GetExams(dojos.data.data, grades.data.data, teachers.data.data, 1);
  };

  const GetExams = async (dojos, grades, teachers, page) => {
    setLoading(true);

    const exams = await axios
      .get(
        `${API_URL}/temp-exams?populate=tempUser&sort[0]=id%3Adesc&filters[date][$lt]=2021-01-01&filters[createdByUser][$eq]=${usuario.id}&filters[examination][id][$null]=true&filters[state][$in][0]=NEW&filters[state][$in][1]=UPDATED&filters[state][$in][2]=CREATED&pagination[page]=${page}&pagination[pageSize]=${PAGE_SIZE}&pagination[withCount]=true`,
        headerRequest
      )
      .then((exams) => {
        setPagination(exams.data.meta.pagination);
        return exams.data.data;
      });

    Promise.all(
      exams.map(async (exam) => {
        exam.grade = GetGradeName(grades, exam.attributes.grade_id);
        if (!exam.grade || exam.grade === "") {
          exam.grade = `No existe (${exam.attributes.grade_id})`;
        }
        exam.dojo = GetDojoName(dojos, exam.attributes.dojo_id);
        if (!exam.dojo || exam.dojo === "") {
          exam.dojo = `No existe (${exam.attributes.dojo_id})`;
        }

        switch (exam.attributes.state) {
          case "NEW":
            exam.resultado = "";
            break;
          case "CREATED":
          case "UPDATED":
            exam.resultado = "Procesado";
            break;
          default:
            exam.resultado = "Pendiente";
            break;
        }

        const tempUser = exam.attributes.tempUser;
        if (tempUser?.data?.id) {
          exam.fullname =
            tempUser.data.attributes.lastname +
            ", " +
            tempUser.data.attributes.name;
          exam.tempUserId = tempUser.data.id;
        } else {
          exam.fullname = "No existe";
        }

        const teacher = GetTeacher(
          teachers,
          exam.attributes.responsibleDocNumber
        );
        if (teacher) {
          exam.responsibleId = teacher.id;
          exam.responsibleName = teacher.attributes.name;
        } else {
          exam.responsibleName = `No existe (${exam.attributes.responsibleDocNumber})`;
        }

        return exam;
      })
    ).then((exams) => {
      setExams(exams);
      setLoading(false);
    });
  };

  function GetTeacher(teachers, doc) {
    return teachers.find((t) => t.attributes.docNumber == doc);
  }

  const ExamEdit = (e) => {
    setExamDetail(e);
    setShowModal(true);
  };

  const ExamDelete = (e) => {
    setLoading(true);
    axios.delete(`${API_URL}/temp-exams/${e.id}`, headerRequest).then(() => {
      if (e.tempUserId) {
        axios
          .delete(`${API_URL}/temp-users/${e.tempUserId}`, headerRequest)
          .then(() => {
            setLoading(false);
            GetExams(dojos, grades, teachers, currentPage);
          });
      } else {
        setLoading(false);
        GetExams(dojos, grades, teachers, currentPage);
      }
    });
  };

  const renderData = (
    <>
      <Table striped hover size="sm" responsive="sm">
        <thead>
          <tr>
            <th>DNI</th>
            <th>Nombre</th>
            <th>Graduación</th>
            <th>Fecha</th>
            <th>Examinador</th>
            <th>
              <Button
                size="sm"
                variant="success"
                onClick={() => ExamEdit(null)}
              >
                CREAR
              </Button>
            </th>
          </tr>
        </thead>
        <tbody>
          {exams.length < 1 ? (
            <tr>
              <td colSpan="6" align="center">
                No hay datos pendientes.
              </td>
            </tr>
          ) : (
            exams.map((e) => (
              <tr key={e.id}>
                <td align="center">{e.attributes.docNumber}</td>
                <td align="left">{e.fullname}</td>
                <td align="center">{e.grade}</td>
                <td align="center">
                  {moment(e.attributes.date).format(displayFormat)}
                </td>
                <td align="left">{e.responsibleName}</td>
                <td align="center" className="w140">
                  {e.resultado === "" ? (
                    <>
                      <Button
                        size="sm"
                        className="me-2"
                        onClick={() => ExamEdit(e)}
                        variant="warning"
                      >
                        Editar
                      </Button>
                      <Button
                        size="sm"
                        onClick={() => ExamDelete(e)}
                        variant="danger"
                      >
                        Borrar
                      </Button>
                    </>
                  ) : (
                    <Button disabled variant="outline-secondary">
                      {e.resultado}
                    </Button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={pagination.total}
        pageSize={PAGE_SIZE}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3" fluid="lg">
      <h4>INFORMAR ANTERIORES A 2021</h4>
      <p>Ingrese exámenes aprobados previos al 01/01/2021.</p>
      {isLoading ? <Spinner animation="border" /> : renderData}
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="modal-background"
        ></div>
      )}
      {showModal && (
        <ModalCrud
          show={showModal}
          exam={examDetail}
          dojos={dojos}
          grades={grades}
          teachers={teachers}
          onHide={(saved) => {
            setShowModal(false);
            if (saved === true) GetExams(dojos, grades, teachers, currentPage);
          }}
        />
      )}
    </Container>
  );
}
